import React from 'react';
import AppContainer from "../components/AppContainer";
import OpsText from "../ops-library/ops-text";

const PageNotFound = () => {
    return (
        <AppContainer
            content={
                <div className="window-content-container justify-content-center">
                    <OpsText type="title2" className="w-100 h-100" color="primary-3" weight={700}
                             content={"Stránka sa nenašla"}/>
                </div>
            }
        />
    );
};

export default PageNotFound;